var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "#FE5B4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.011 9.206V6H9.425c.206-.223.42-.48.635-.771V4.62H7.437a9.06 9.06 0 01.283-.42l-.9-.206C6.09 5.05 5.243 5.864 4.265 6.446l.566.686a10.2 10.2 0 00.497-.343h4.817v.437H5.62v.754h4.526v.437H5.293v.789h5.717zM8.337 6H6.263c.205-.205.402-.42.6-.643h2.1c-.215.24-.42.455-.626.643zM5.183 9.574a5.285 5.285 0 01-.832 1.75l.772.488c.402-.583.711-1.269.934-2.057l-.874-.18zm4.225 2.35c.343 0 .6-.06.772-.18.188-.138.317-.55.386-1.235l-.85-.283c-.025.437-.076.703-.162.788a.422.422 0 01-.309.112H7.583c-.18 0-.266-.103-.266-.309V9.532h-.892v1.482c0 .6.3.91.9.91h2.083zm-.943-2.667l-.737.455c.386.402.686.771.909 1.097l.746-.514a9.486 9.486 0 00-.918-1.038zm2.529.112l-.72.454c.497.686.883 1.311 1.174 1.877l.746-.523c-.283-.514-.686-1.122-1.2-1.808z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/alarm.86eb21a1.svg";
export { SvgAlarm as ReactComponent };